if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        config.body = formData;

        const variantId = formData.get('id');
        const quantity = formData.get('quantity') || 1;

        try {
          const response = await fetch(`${routes.cart_add_url}`, config);
          const data = await response.json();

          if (data.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: variantId,
              errors: data.errors || data.description,
              message: data.message,
            });

            this.handleErrorMessage(data.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span')?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }

            this.error = true;
            return;
          }

          this.error = false;

          // Suppress the cart notification so it never shows
          const cartNotification = document.querySelector('cart-notification');
          if (cartNotification) {
            const notifEl = document.getElementById('cart-notification');
            if (notifEl) {
              notifEl.classList.remove('animate', 'active');
              notifEl.style.display = 'none';
            }
          }

          // Open cart drawer with fresh contents
          await this.openCartDrawer();

          // Publish cart update AFTER drawer is open so subscribers
          // (like CartItems) refresh inside the already-open drawer
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: data,
          });

          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: {
              productId: this.dataset.productId,
              variantId: variantId,
              quantity: quantity,
              cartData: data
            }
          }));

        } catch (error) {
          this.handleErrorMessage('Der skete en fejl. Prøv igen.');
        } finally {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
        }
      }

      async openCartDrawer() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;

        // Suppress notification
        const notifEl = document.getElementById('cart-notification');
        if (notifEl) {
          notifEl.classList.remove('animate', 'active');
          notifEl.style.display = 'none';
        }

        // Remove is-empty class before render to prevent header from being hidden
        cartDrawer.classList.remove('is-empty');

        // Fetch sections and let CartDrawer.renderContents() handle the update
        try {
          const sections = cartDrawer.getSectionsToRender().map(s => s.id).join(',');
          const res = await fetch(`${routes.cart_url}?sections=${sections}`);
          const sectionsData = await res.json();
          cartDrawer.renderContents({ sections: sectionsData });
        } catch (e) {
          // Fallback: just open with current content
          cartDrawer.open();
        }

        // Update cart count badge in br-header
        try {
          const countRes = await fetch(`${routes.cart_url}`, { headers: { 'Accept': 'application/json' } });
          const cartData = await countRes.json();
          const badge = document.querySelector('.br-header__cart-count');
          if (badge && cartData.item_count !== undefined) {
            badge.textContent = cartData.item_count;
            if (cartData.item_count > 0) {
              badge.classList.remove('br-header__cart-count--hidden');
            } else {
              badge.classList.add('br-header__cart-count--hidden');
            }
          }
        } catch (e) {}
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}